import { SentryApiClient } from '_generated/api';

export function toOrderDirection(dir: 'asc' | 'desc') {
  return dir === 'asc'
    ? SentryApiClient.OrderDirection.Ascending
    : SentryApiClient.OrderDirection.Descending;
}
